import { render } from "./baikeDetail.vue?vue&type=template&id=121aaa6b&scoped=true"
import script from "./baikeDetail.vue?vue&type=script&lang=js"
export * from "./baikeDetail.vue?vue&type=script&lang=js"

import "./baikeDetail.vue?vue&type=style&index=0&id=121aaa6b&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121aaa6b"]])

export default __exports__